













































import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import pageRequest from '@/store/models/page-request'
@Component({})
export default class DispatchManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	page: number = 1
	pageSize: number = 10
	totalCount: number = 0
	dispatchList: Array<any> = []
	searchForm: pageRequest = new pageRequest()
	onClickLeft() {
		window.history.go(-1)
	}
	// 页面初次加载
	async onLoad() {
		this.error = false
		this.searchForm.page += 1
		if (this.totalCount !== 0 && this.dispatchList.length === this.totalCount) return
		await this.searchDispatchList()
	}
	// 查询数据
	async searchDispatchList() {
		await ajax
			.get('/api/maintainrecord/return-visit-record-page-list', { params: this.searchForm })
			.then((rep) => {
				this.dispatchList.push(...rep.data.result.items)
				this.totalCount = rep.data.result.total
				if (this.dispatchList.length === this.totalCount) this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
	}
	uploadBtn(val: any) {
		this.$router.push({
			path: '/uploadPhoto', query: {
				no: val.no
			}
		})
	}
	previewBtn(val: any) {
		this.$router.push({ path: '/previewPhoto', query: { urls: val.fileUrls } })
	}
	async created() {
		this.dispatchList = []
	}
}
